import { createPortal } from 'react-dom';

// "2h 5m" / "12m" / "40s" since a unix timestamp (seconds).
export function sinceLabel(ts) {
  const s = Math.max(0, Math.floor(Date.now() / 1000 - ts));
  const d = Math.floor(s / 86400), h = Math.floor(s % 86400 / 3600), m = Math.floor(s % 3600 / 60);
  if (d) return `${d}d ${h}h`;
  if (h) return `${h}h ${m}m`;
  if (m) return `${m}m`;
  return `${s}s`;
}

// The synthetic "N cameras offline" row from /ui/alerts (is_camera_offline): no
// snapshot or clip — it lists which cameras are down and for how long.
export default function CamOfflineModal({ alert, onClose }) {
  const cams = alert.cameras || [];
  return createPortal(
    <div onClick={onClose}
      style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.5)', zIndex: 10000,
               display: 'flex', alignItems: 'center', justifyContent: 'center', padding: 16 }}>
      <div onClick={e => e.stopPropagation()}
        style={{ background: 'var(--card-bg, #fff)', color: 'inherit', borderRadius: 12, width: 'min(420px, 100%)',
                 maxHeight: '80vh', overflowY: 'auto', padding: 20, boxShadow: '0 10px 30px rgba(0,0,0,0.3)' }}>
        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: 12 }}>
          <h3 style={{ margin: 0, fontSize: 17 }}>📴 {alert.label || `${cams.length} cameras offline`}</h3>
          <button onClick={onClose} aria-label="Close"
            style={{ background: 'none', border: 'none', fontSize: 20, cursor: 'pointer', color: 'inherit' }}>✕</button>
        </div>
        {cams.length === 0 ? (
          <p style={{ margin: 0, opacity: 0.7 }}>All cameras are back online.</p>
        ) : cams.map(c => (
          <div key={c.cam_idx}
            style={{ display: 'flex', justifyContent: 'space-between', gap: 12, padding: '10px 0',
                     borderTop: '1px solid rgba(128,128,128,0.2)' }}>
            <span style={{ fontWeight: 600 }}>{c.cam_name}</span>
            <span style={{ color: '#e74c3c', whiteSpace: 'nowrap' }}
              title={new Date(c.since_ts * 1000).toLocaleString()}>
              offline {sinceLabel(c.since_ts)}
            </span>
          </div>
        ))}
      </div>
    </div>,
    document.body
  );
}
